<template>
  <div class="tw-flex tw-flex-col sm:tw-items-center tw-justify-center tw-min-h-screen tw-bg-gray-100">
    <base-card shadow no-padding class="tw-w-full sm:tw-max-w-md">
      <div class="tw-py-4 tw-flex tw-justify-center">
        <component :is="logo" class="tw-w-3/4 tw-max-h-32" />
      </div>
      <base-content>
        <div class="tw-mb-5 tw-text-center tw-text-lg">Create your Business</div>
        <div
          class="tw-w-full tw-px-3 sm:tw-max-w-md tw-rounded-lg tw-bg-red-50 tw-text-red-500 tw-text-sm tw-font-normal tw-border tw-border-red-400 tw-py-3 tw-text-center tw-flex tw-mb-5"
          v-if="errors.length > 0"
        >
          <alert-icon class="tw-h-6 tw-w-6 tw-text-red-500 tw-mr-2 tw-my-auto" />
          <ul class="tw-text-left tw-px-2 tw-mb-0">
            <li v-for="error in errors" :key="error.message">
              {{ error.message }}
            </li>
          </ul>
        </div>
        <base-form ref="form" v-model="isFormValid" @submit.prevent>
          <base-text-field label="Business Name" type="text" placeholder="Enter the name of your business" v-model="business" @keyup.enter="submit()" required />
          <base-text-field label="Your Full Name (First and Last)" type="text" placeholder="Enter you first and last name" v-model="name" @keyup.enter="submit()" required />
          <base-email-field label="Email Address" type="email" placeholder="Enter your email" v-model="email" @keyup.enter="submit()" required />
          <base-phone-number-input label="Phone number" placeholder="please enter your phone number" v-model="phone" :e164.sync="phone164" required />
          <base-text-field label="Password" type="password" placeholder="Enter your new password" v-model="password" required class="tw-mt-2" />
          <base-text-field
            label="Confirm password"
            type="password"
            placeholder="Confirm your new password"
            v-model="confirmPassword"
            :rules="passwordRules"
            required
            class="tw-mt-2"
          />

          <base-button type="primary" class="tw-w-full tw-mt-4" @click="submit()" :disabled="isLoading">
            Let's get started!
          </base-button>

          <div class="tw-mt-4">
            <div class="tw-text-center tw-text-sm tw-text-gray-500">
              By continuing, you agree to Predictile's<br /><a class="tw-p-0" href="https://www.predictile.com/member-terms-of-service/index.html" target="_blank"
                >Terms of Service</a
              >
              |
              <a class="tw-p-0" href="https://www.predictile.com/privacy-policy/index.html" target="_blank">Privacy Policy</a>
            </div>
            <div class="tw-border-t-0 tw-border-gray-500 tw-mt-4 tw-text-center tw-pt-3">
              I already have an account.
              <base-button type="text" class="tw-p-0 tw-my-auto" @click="href('/signin')">
                Sign In
              </base-button>
            </div>
          </div>
        </base-form>
      </base-content>
    </base-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AlertIcon } from "@/assets/svgs";
import PredictileLogo from "@/assets/images/predictile-logo-square.svg";

export default {
  name: "BusinessSignUpView",
  components: {
    AlertIcon,
    PredictileLogo,
  },
  data() {
    return {
      isLoading: false,
      business: null,
      name: null,
      email: null,
      phone: null,
      phone164: "",
      password: null,
      confirmPassword: null,
      errors: [],
      isFormValid: true,
      passwordRules: [() => this.newPassword === this.confirmNewPassword || "Please enter matching passwords"],
    };
  },
  computed: {
    ...mapGetters("organization", ["cobrandId"]),
    logo() {
      return "predictile-logo";
    },
  },
  methods: {
    submit() {
      this.errors = [];

      if (!this.$refs.form.validate()) return;

      this.isLoading = true;
      this.$axios
        .post("/signup/business", {
          business: this.business,
          name: this.name,
          email: this.email,
          phone: this.phone164,
          password: this.password,
        })
        .then(() => {
          this.isLoading = false;
          this.$router.push("/signup/business/success");
        })
        .catch((err) => {
          this.isLoading = false;
          this.errors = err.response.data;
        });
    },
    href(path) {
      this.$router.push(path);
    },
  },
};
</script>
